export default __webpack_public_path__ + "static/media/blockfunds.33345949.svg";